import { useForm } from "react-hook-form";
import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import BaseModal from "../../../SharedComponents/components/Modals/BaseModal";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { getFullName } from "../../../SharedComponents/utils/helpers/getFullName";
import ControllerTextArea from "../../../SharedComponents/formComponents/baseFormComponents/ControllerTextArea";
import { requestSendSupportMessage } from "../../reduxStore/sagas/requests/partOfferReviews";

const PartOfferReportIssueModal = ({
    open,
    setOpen,
    partOffer
}) => {
    const sellerName = getFullName(partOffer.User.firstname, partOffer.User.lastname);

    const methods = useForm();
    const { control, getValues } = methods;

    const getIssuePayload = () => {
        const { message } = getValues();

        const payload = {
            message: message
        };

        return payload;
    };


    const handleConfirmReportIssue = async () => {
        try {
            const payload = getIssuePayload();

            const createdRate = await requestSendSupportMessage(payload);

            if (createdRate.data) {
                setOpen(false);
                alert('Uspešno ste prijavili problem!');
            };
        }

        catch (error) {
            alert(error.response.data.error);
        };
    };


    return (
        <BaseModal
            open={open}
            setOpen={setOpen}
            externalStyle={styles.externalModalStyle}
        >
            <div style={styles.topLevelContainer}>
                <div>
                    <div style={styles.mainContainer}>
                        <p style={styles.title}>
                            Prijavi problem
                        </p>
                    </div>

                    <div style={styles.itemsContainer}>
                        <p style={styles.text}>
                            {`Ponuda: ${partOffer.title}`}
                        </p>
                        <p style={styles.text}>
                            {`Prodavac: ${sellerName}`}
                        </p>
                    </div>

                    <div>
                        <div style={styles.controllerTextArea}>
                            <ControllerTextArea
                                name={"message"}
                                control={control}
                                placeholder={"Opis problema"}
                                width={"100%"}
                                height={180}
                            />
                        </div>
                    </div>

                </div>

                <div style={styles.modalFooterContariner}>
                    <div style={styles.modalFooterContarinerUpperRow}>
                        <div
                            onClick={() => setOpen(false)}
                            style={styles.clickable}
                        >
                            <p style={styles.backTitle}>
                                Odustani
                            </p>
                        </div>

                        <BaseButton
                            onClick={() => handleConfirmReportIssue()}
                            variant={ButtonVariantEnum.BLACK}
                            text={"Prijavi problem"}
                            IconComponent={RightArrowExtendedIconSVG}
                        />
                    </div>
                </div>
            </div>

        </BaseModal>
    );
};


export default PartOfferReportIssueModal;

const styles = {
    externalModalStyle: {
        minHeight: "614px",
        width: "600px",
        paddingBottom: 40,
        paddingInline: 80
    },
    clickable: {
        cursor: 'pointer'
    },
    controllerTextArea: {
        marginTop: 40
    },
    topLevelContainer: {
        height: "100%",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 40
    },
    mainContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 40
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "24px",
        fontWeight: 600,
        color: "rgba(0, 0, 0, 0.87)"
    },
    text: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeight: 400,
        color: "rgba(0, 0, 0, 0.87)"
    },
    itemsContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    backTitle: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "20px",
        color: "#5B21B6"
    },
    modalFooterContariner: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10
    },
    modalFooterContarinerUpperRow: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20
    },
    footerInfoText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "#000000de"
    }
}